export class ForgotPasswordModel {
  username: string = '';
}
